import PremiumPlans from '../schema/PremiumPlans';
import PremiumApi from '../../api/premium';
import { PREMIUM_PLANS as premiumPlansTypes } from '../mutation-types';

const actions = {
  insert({
    commit
  }, payload) {
    commit(premiumPlansTypes.UPSERT, payload);
  },
  fund(context, payload) {
    return new Promise(function(resolve, reject) {
      PremiumApi.fund(payload)
        .then((res) => {
          if (res.data.status === 'ok') {
            return resolve(res);
          }
          reject(res.data.errors);
        })
        .catch((err) => reject(err));
    });
  }
};

const mutations = {
  [premiumPlansTypes.UPSERT](state, payload) {
    PremiumPlans.update({
      _id: payload._id
    }, payload, {
      upsert: true
    });
  }
};

export default {
  namespaced: true,
  state: PremiumPlans.state,
  getters: PremiumPlans.getters,
  actions,
  mutations
};
